
import WhoWeAreSection from './components/WhoWeAreSection';
import OurFactoriesSection from './components/OurFactoriesSection';
import OurCapabilitiesSection from './components/OurCapabilitiesSection';
import CertificationsSection from './components/CertificationsSection';
import ValuesSection from './components/ValuesSection';
import LogoWall from './components/LogoWall';

export default function About() {
  return (
    <div className="min-h-screen">
      <WhoWeAreSection />
      <OurFactoriesSection />
      <OurCapabilitiesSection />
      <CertificationsSection />
      <ValuesSection />
      <LogoWall />
    </div>
  );
}